import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, Navigate, Outlet, RouterProvider } from "react-router-dom";
import { AuthProvider } from "./components/AuthProvider";
import { PageTitle } from "./components/PageTitle";
import { AdminCalls } from "./pages/AdminCalls";
import { AdminDashboard } from "./pages/AdminDashboard";
import { AdminNumbers } from "./pages/AdminNumbers";
import { AdminSettings } from "./pages/AdminSettings";
import { AdminUsers } from "./pages/AdminUsers";
import { Login } from "./pages/Login";
import { RequireSession } from "./pages/RequireSession";
import { UserDialer } from "./pages/UserDialer";
import { UserHistory } from "./pages/UserHistory";
import "./styles.css";
function RootLayout() {
    return (_jsxs(_Fragment, { children: [_jsx(PageTitle, {}), _jsx(Outlet, {})] }));
}
const router = createBrowserRouter([
    {
        path: "/",
        element: _jsx(RootLayout, {}),
        children: [
            { index: true, element: _jsx(Navigate, { to: "/login", replace: true }) },
            { path: "login", element: _jsx(Login, { role: "USER" }) },
            { path: "admin/login", element: _jsx(Login, { role: "ADMIN" }) },
            {
                path: "admin",
                element: _jsx(RequireSession, { role: "ADMIN" }),
                children: [
                    { index: true, element: _jsx(AdminDashboard, {}) },
                    { path: "users", element: _jsx(AdminUsers, {}) },
                    { path: "numbers", element: _jsx(AdminNumbers, {}) },
                    { path: "calls", element: _jsx(AdminCalls, {}) },
                    { path: "settings", element: _jsx(AdminSettings, {}) }
                ]
            },
            {
                path: "app",
                element: _jsx(RequireSession, { role: "USER" }),
                children: [
                    { index: true, element: _jsx(UserDialer, {}) },
                    { path: "history", element: _jsx(UserHistory, {}) }
                ]
            },
            { path: "*", element: _jsx(Navigate, { to: "/login", replace: true }) }
        ]
    }
]);
ReactDOM.createRoot(document.getElementById("root")).render(_jsx(React.StrictMode, { children: _jsx(AuthProvider, { children: _jsx(RouterProvider, { router: router }) }) }));
